import { createSelector } from '@ngrx/store';
import { getOneClickState } from '../reducers';

export const getOneClickNextWorkingDayState = createSelector(
  getOneClickState,
  state => state.nextWorkingDayState,
);

export const getOneClickNextWorkingDay = createSelector(
  getOneClickNextWorkingDayState,
  state => state.nextWorkingDay,
);
